export default __webpack_public_path__ + "static/r500-large-e3be059e12eff3bab853f288ccf66e84.png";